module.exports = __webpack_public_path__ + "static/media/aiIcon.8d8863c8.svg";